var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass:
        "d-flex pl-0 mb-0 justify-content-center align-items-center paginate-links"
    },
    [
      _c(
        "li",
        {
          staticClass: "left-arrow",
          class: _vm.page === 1 && "disabled",
          on: {
            click: function($event) {
              return _vm.handlePagination("prev")
            }
          }
        },
        [_c("a", [_vm._v("◀")])]
      ),
      _vm._v(" "),
      _vm._l(_vm.displayedPages, function(pageNumber, key) {
        return _c(
          "li",
          {
            key: key,
            class: _vm.page === pageNumber && "active",
            on: {
              click: function($event) {
                return _vm.handlePagination("current", pageNumber)
              }
            }
          },
          [_c("a", [_vm._v(_vm._s(pageNumber))])]
        )
      }),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "right-arrow",
          class: _vm.page >= _vm.pages.length && "disabled",
          on: {
            click: function($event) {
              return _vm.handlePagination("next")
            }
          }
        },
        [_c("a", [_vm._v("▶")])]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-849a166c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-849a166c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = null
// module chunks = 